declare global {
  interface Window {
    centerpieceapiconfig?: {
      apiBaseUrl: { [key: string]: string };
      routeNames: { [key: string]: string };
      blockAPI?: boolean;
    };
  }
}

export const routeNames: {
  [key: string]: string;
} = window.centerpieceapiconfig?.routeNames || {};

export const apiBaseUrl: {
  [key: string]: string;
} = window.centerpieceapiconfig?.apiBaseUrl || {};
